export default __webpack_public_path__ + "images/loggedout/home/modularPage/decodable_books-6e86abd0486105806a9a03667885bf78.png";